import { Button, Card, CardActions, CardHeader, Stack, Typography } from "@bvhi/ui-base";
import { HomeIcon, SyncIcon } from "@bvhi/ui-icons";
import { ArrowLeftIcon } from "@mui/x-date-pickers";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { getAppConfig } from "../config/config";

export interface DefaultNotFoundFallbackProps {
  resetErrorBoundary: (...args: unknown[]) => void;
}

export const DefaultNotFoundFallback = ({ resetErrorBoundary }: DefaultNotFoundFallbackProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation(["errors"]);

  return (
    <Stack pt={2} spacing={2}>
      <Card>
        <CardHeader
          title={t("errors:not.found.card.title")}
          subheader={
            <Typography>
              {t("errors:not.found.card.sub.title.1")}{" "}
              <a href={`mailto:${getAppConfig().env.supportMailAdesso}`}>{t("errors:not.found.card.sub.title.2")}</a>{" "}
              {t("errors:not.found.card.sub.title.3")}
            </Typography>
          }
        />

        <CardActions>
          <Button onClick={resetErrorBoundary} startIcon={<SyncIcon />}>
            {t("errors:error.card.button.retry")}
          </Button>
          <Button onClick={() => history.go(-1)} startIcon={<ArrowLeftIcon />}>
            {t("errors:error.card.button.back")}
          </Button>
          <Button onClick={() => void navigate({ to: "/app/dashboard" })} startIcon={<HomeIcon />}>
            {t("errors:error.card.button.to.dashboard")}
          </Button>
        </CardActions>
      </Card>
    </Stack>
  );
};
